import { useSelector } from "react-redux";
import { getParentForm } from "redux_dir/features/parentSlice";
import { Gift } from "tabler-icons-react";
import { ENABLE_CREDIT_SYSTEM } from "constants";

/**
 * Badge crédits.
 * `compact` : version pastille pour la barre de navigation.
 */
const Credit = ({ compact = false, onLight = false }) => {
  const parent = useSelector(getParentForm);

  const credits = parent?.credits || 0;
  const creditsNumber = parseInt(credits);

  if (compact) {
    const label = !ENABLE_CREDIT_SYSTEM
      ? "Gratuit"
      : creditsNumber > 0
        ? `${creditsNumber} pts`
        : "0 pt";

    return (
      <div
        className={`flex items-center gap-1 rounded-full pl-2 pr-3 h-8 ${
          onLight
            ? "bg-green-500/10 text-green-700"
            : "bg-white/20 text-white"
        }`}
      >
        <Gift size={14} strokeWidth={2.5} />
        <span className="text-[12px] font-bold leading-none">{label}</span>
      </div>
    );
  }

  // --- Système de crédits désactivé : badge "GRATUIT" sans nombre ---
  if (!ENABLE_CREDIT_SYSTEM) {
    return (
      <div className="relative">
        <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full px-3 py-1.5 shadow-md flex flex-col items-center justify-center min-w-[70px] hover:shadow-lg transition-all duration-300 hover:scale-105">
          <Gift size={14} strokeWidth={2.5} />
          <div className="text-[10px] font-bold leading-tight text-center mt-0.5">
            GRATUIT
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-full pointer-events-none"></div>
      </div>
    )
  }

  return creditsNumber > 0 ? (
    <div className="relative">
      {/* Badge vert compact intégré dans le header */}
      <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full px-3 py-1.5 shadow-md flex flex-col items-center justify-center min-w-[90px] hover:shadow-lg transition-all duration-300 hover:scale-105">
        {/* Icône cadeau et nombre sur la même ligne */}
        <div className="flex items-center gap-1 mb-0.5">
          <Gift size={14} strokeWidth={2.5} />
          <span className="text-lg font-extrabold leading-none">
            {creditsNumber}
          </span>
        </div>

        {/* Texte "diagnostic GRATUIT" compact */}
        <div className="text-[9px] font-bold leading-tight text-center">
          diagnostic{creditsNumber > 1 ? "s" : ""}
          <span className="block text-[8px]">
            GRATUIT{creditsNumber > 1 ? "S" : ""}
          </span>
        </div>

        {/* Sous-texte "Utilisez-le" très petit */}
        <div className="text-[7px] font-medium opacity-90 italic">
          Utilisez-le
        </div>
      </div>

      {/* Effet de brillance subtil */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-full pointer-events-none"></div>
    </div>
  ) : (
    <div className="relative">
      <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full px-3 py-1.5 shadow-md flex flex-col items-center justify-center min-w-[70px] hover:shadow-lg transition-all duration-300 hover:scale-105">
        <Gift size={14} strokeWidth={2.5} />
        <div className="text-[10px] font-bold leading-tight text-center mt-0.5">
          Aucun crédit
        </div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-full pointer-events-none"></div>
    </div>
  )
};

export default Credit;
